function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "password-visible",
  transform: "translate(-70 -0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M84.772,6.9C83.96,5.985,81.032,3,77.5,3S71.04,5.985,70.227,6.9a.907.907,0,0,0,0,1.2c.813.915,3.741,3.9,7.272,3.9s6.461-2.985,7.274-3.9A.9.9,0,0,0,84.772,6.9ZM77.5,10.971c-3.009,0-5.6-2.552-6.434-3.471.837-.922,3.427-3.471,6.434-3.471S83.1,6.578,83.935,7.5C83.1,8.422,80.508,10.971,77.5,10.971Z",
  fill: "fill"
}), /*#__PURE__*/React.createElement("path", {
  d: "M77.5,5.1a2.4,2.4,0,1,0,2.376,2.4A2.387,2.387,0,0,0,77.5,5.1Zm0,3.763A1.367,1.367,0,1,1,78.855,7.5,1.362,1.362,0,0,1,77.5,8.867Z",
  fill: "fill"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "password-hidden",
  transform: "translate(21999.5 6302.75)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M105.536,15a.536.536,0,0,1-.379-.915L119.085.157a.536.536,0,0,1,.758.758L105.915,14.843A.534.534,0,0,1,105.536,15Z",
  transform: "translate(-22104.5 -6302.75)",
  fill: "fill"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-22104.5 -6302.75)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M108.078,10.543l.74-.74a13.283,13.283,0,0,1-2.753-2.3c.837-.922,3.427-3.471,6.434-3.471a5.972,5.972,0,0,1,1.8.294l.805-.8A7.181,7.181,0,0,0,112.5,3c-3.531,0-6.459,2.985-7.272,3.9a.907.907,0,0,0,0,1.2A14.47,14.47,0,0,0,108.078,10.543Z",
  fill: "fill"
}), /*#__PURE__*/React.createElement("path", {
  d: "M116.922,4.457l-.74.74a13.275,13.275,0,0,1,2.753,2.3c-.837.922-3.427,3.472-6.436,3.472a5.982,5.982,0,0,1-1.8-.3l-.8.805a7.2,7.2,0,0,0,2.6.518c3.533,0,6.461-2.985,7.274-3.9a.9.9,0,0,0,0-1.2A14.426,14.426,0,0,0,116.922,4.457Z",
  fill: "fill"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-22104.5 -6302.75)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M111.158,7.63a1.1,1.1,0,0,1-.013-.13A1.362,1.362,0,0,1,112.5,6.133a1.3,1.3,0,0,1,.141.014l.829-.829a2.329,2.329,0,0,0-.97-.214,2.394,2.394,0,0,0-2.172,3.357Z",
  fill: "fill"
}), /*#__PURE__*/React.createElement("path", {
  d: "M113.842,7.37c0,.044.013.086.013.13A1.363,1.363,0,0,1,112.5,8.867a1.283,1.283,0,0,1-.139-.014l-.83.829a2.332,2.332,0,0,0,.969.214,2.394,2.394,0,0,0,2.174-3.356Z",
  fill: "fill"
})));

function SvgIconShowPassword(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShowPassword);
export default __webpack_public_path__ + "static/media/icon_show-password.46b4a6f3.svg";
export { ForwardRef as ReactComponent };